import { render, staticRenderFns } from "./incidents-dossier.vue?vue&type=template&id=bb46d9c2&"
import script from "./incidents-dossier.ts?vue&type=script&lang=ts&"
export * from "./incidents-dossier.ts?vue&type=script&lang=ts&"
import style0 from "../../shared/styles/statistical-analysis-dossier.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./incidents-dossier.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports